import { render, staticRenderFns } from "./buttonModal.vue?vue&type=template&id=cc66f628&scoped=true"
import script from "./buttonModal.vue?vue&type=script&lang=js"
export * from "./buttonModal.vue?vue&type=script&lang=js"
import style0 from "./buttonModal.vue?vue&type=style&index=0&id=cc66f628&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc66f628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc66f628')) {
      api.createRecord('cc66f628', component.options)
    } else {
      api.reload('cc66f628', component.options)
    }
    module.hot.accept("./buttonModal.vue?vue&type=template&id=cc66f628&scoped=true", function () {
      api.rerender('cc66f628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/mobilePreview/components/buttonModal.vue"
export default component.exports